/**
 * add Vue-Router support
 */
export default {
  props: {
    url: String,
    replace: Boolean,
    to: [String, Object]
  },
  methods: {
    routerLink: function routerLink() {
      var to = this.to,
          url = this.url,
          $router = this.$router,
          replace = this.replace;

      if (to && $router) {
        $router[replace ? 'replace' : 'push'](to);
      } else if (url) {
        replace ? location.replace(url) : location.href = url;
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.5.2@vant/es/mixins/router-link.js
// module id = null
// module chunks = 